// extracted by mini-css-extract-plugin
module.exports = {"social":"Social_social__AoSDP","social__icon":"Social_social__icon__TbeWG","telegram":"Social_telegram__DGJ33","instagram":"Social_instagram__3pNXf"};